import React from 'react'

import Container from '../Container'

const Redemptions = ({ children }) => (
  <>
    <Container as="main">
      {children}
    </Container>
  </>
)

export default Redemptions
